
















import { Component, Vue, Prop } from 'vue-property-decorator';
import MenuIcon from '@/components/icons/MenuIcon.vue';
import MenuOpenIcon from '@/components/icons/MenuOpenIcon.vue';


@Component({
  components: {
    MenuIcon,
    MenuOpenIcon
  }
})
export default class MenuButton extends Vue {
  private menuOpen:Boolean = false;
}
